import ConfirmationPanel from './ConfirmationPanel';

export default ConfirmationPanel;
